import React, { useEffect, useState } from 'react';
import Preloader from '../Components/Preloader';
import { NavLink } from 'react-router-dom';
import Error_Seo from '../SEO/Error_Seo';

function Error() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);
    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Error_Seo />
                    <div className="page-wrapper">
                        {/* Internal CSS */}
                        <style>
                            {`
                        .page-wrapper {
            width: 100%;
            height: 100vh; /* Full viewport height */
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .error-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        }
                    `}
                        </style>
                        {/* Content Wrapper Start */}
                        <div className="content-wrapper">
                            {/* Error  Section start */}
                            <div className="error-wrap ptb-100">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="error-content">
                                                <span className="trans_text v4">404</span>
                                                <h2>Opps! Page not found</h2>
                                                <p>
                                                    We're sorry, the page you have looked for does not exist in our database! Maybe go to our home page or try to use a search?
                                                </p>
                                                <NavLink to="/" className="btn style1">Back to Home</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Error  Section end */}
                        </div>
                        {/* Content Wrapper End */}
                    </div>
                </>
            )}
        </div>
    );
}

export default Error
